import { Injectable } from '@angular/core';
import { CookieService as NGXCookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class CookieService {
  constructor(private ngxCookieService: NGXCookieService) {}

  // Defina um cookie
  setCookie(
    name: string,
    value: string,
    expires?: number | Date,
    path?: string,
    domain?: string,
    secure?: boolean,
    sameSite?: 'Lax' | 'Strict' | 'None',
  ): void {
    this.ngxCookieService.set(name, value, expires, path, domain, secure, sameSite);
  }

  // Obtenha um cookie pelo nome
  getCookie(name: string): string {
    return this.ngxCookieService.get(name);
  }

  // Verifique se um cookie existe
  checkCookie(name: string): boolean {
    return this.ngxCookieService.check(name);
  }

  // Exclua um cookie
  deleteCookie(name: string, path?: string, domain?: string): void {
    this.ngxCookieService.delete(name, path, domain);
  }
}
